import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  disabledWhenVariant,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: validator('presence', {
    presence: true,
    disabled: disabledWhenVariant(),
  }),
});

export default class SectionModel extends Model.extend(Validations) {
  @attr('string') belonging;
  @attr('string') name;
  @attr('string') shortName;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter and setter
  get displayHeadline() {
    return this.name;
  }

  get displayLabel() {
    return this.name;
  }
}
